export default {
  session: { currentUser: {} },
  users: [],
  user: {},
  files: [],
  organization: {},
  countries: [],
  appList: [],
  applications: [],
  application: { users: [] },
  invitations: {
    results: [],
    pagination: {},
  },
  applicationMetrics: {
    scoredCalculatedChart: [],
    scoredCalculatedCount: 0,
    fsdsTotalCalls: 0,
    fsdsChargeableCalls: 0,
    fsdsTotalCallsByMonth: [],
    fsdsChargeableCallsByMonth: [],
  },
  fileMetrics: {
    totalFilesUploaded: [],
    totalScoredUsersByMonth: [],
  },
  dashboard: {
    totalApiCalls: [],
    totalChargeableCalls: [],
    successRate: [],
    finscoreTotalUploads: 0,
    finscoreTotalApps: 0,
    finstreamTotalApps: 0,
  },
};
